import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  THERAPIST_PRIMARY_TABS,
  PARENT_PRIMARY_TABS,
} from './navConfig';
import MenuDrawer from './MenuDrawer';

/**
 * Mobile bottom tab bar. Glassmorphism, fixed bottom, 4 evenly-spaced tabs.
 * Hidden on md+ (replaced by SideNav).
 */
export default function BottomTabBar({ user }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const tabs = user?.role === 'parent' ? PARENT_PRIMARY_TABS : THERAPIST_PRIMARY_TABS;

  const isActive = (tab) => {
    if (tab.action) return false;
    if (tab.path === '/') return location.pathname === '/';
    return location.pathname.startsWith(tab.path);
  };

  const handleTap = (tab) => {
    if (tab.action === 'open_drawer') {
      setDrawerOpen(true);
      return;
    }
    if (tab.path) navigate(tab.path);
  };

  return (
    <>
      <nav
        className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/85 backdrop-blur-xl border-t border-stone-200"
        data-testid="bottom-tab-bar"
        // Lift the tap targets ABOVE the platform-injected "Made with Emergent"
        // badge (fixed bottom-right, ~40px tall). The translucent backdrop still
        // extends to the screen edge so the bar reads as one connected surface.
        style={{
          paddingBottom: 'calc(env(safe-area-inset-bottom) + 52px)',
        }}
      >
        <div className="grid grid-cols-4 gap-1 px-2 py-1.5">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const active = isActive(tab);
            return (
              <motion.button
                key={tab.id}
                onClick={() => handleTap(tab)}
                whileTap={{ scale: 0.93 }}
                className="flex flex-col items-center justify-center py-2 rounded-2xl transition-colors"
                data-testid={`nav-${tab.id}`}
                aria-label={tab.label}
              >
                <Icon
                  className={`w-5 h-5 mb-0.5 transition-colors ${
                    active ? 'text-primary stroke-[2.5px]' : 'text-stone-400'
                  }`}
                />
                <span
                  className={`text-[10px] font-medium tracking-wide ${
                    active ? 'text-primary-900' : 'text-stone-500'
                  }`}
                >
                  {tab.label}
                </span>
              </motion.button>
            );
          })}
        </div>
      </nav>
      <MenuDrawer open={drawerOpen} onOpenChange={setDrawerOpen} user={user} />
    </>
  );
}
